import React from "react";
import LoanStepCard from "../../UIComponents/LoanStepCard";// Import the card
import './loanProcess.css'

const loanSteps = [
    {
        number: "01",
        heading: "Apply Online",
        subtext: "Fill out a quick form with basic business details.",
        imgSrc: "/assets/img/manComputer.png",
        background:"#F3C510",
        height:'95%'
    },
     {
        number: "04",
        heading: "Receive Funds Quickly",
        subtext: "Get the loan amount credited to your business account.",
        imgSrc: "/assets/img/sendingMoney.png",
        background:'#CCF8E1',
        rounded:'z-10 top-[-15px] left-[-30px]'
        
    },
     {
        number: "02",
        heading: "Get a Customized Loan Offer",
        subtext: "Based on your eligibility and business needs.",
        imgSrc: "/assets/img/Illustration.png",
        height:'110%',
        width:'120%',
        background:'#CED3ED',
        rounded:'top-[-40px] left-[-20px]'
    },

     {
        number: "05",
        heading: "Repay in Easy EMIs",
        subtext: "Choose a flexible repayment tenure that suits your cash flow.",
        imgSrc: "/assets/img/astronaut.png",
        rounded:'rounded-tl-3xl'
    },
    
    {
        number: "03",
        heading: "Submit Documents",
        subtext: "Minimal paperwork for hassle-free approval.",
        imgSrc: "/assets/img/womenonphone.jpg",
        height:'100%',
        width:'100%',
        rounded:'rounded-tl-3xl'
    },
   {
        number: "06",
        heading: "No Heavy Paperwork",
        subtext: "100% digital process with minimal documentation.",
        imgSrc: "/assets/img/cartoonhand.jpg",
        isOverlay: true,
        overlayImg: "/assets/img/cross.png",
        rounded:'rounded-tl-3xl'
    },
];

const sortedLoanSteps = [...loanSteps].sort((a, b) => Number(a.number) - Number(b.number));


export default function HowBusinessLoansWork() {
    return (
        <section className="relative py-12  px-4 max-w-6xl mx-auto mt-5 z-0">
            {/* overlay */}
            <div className="absolute h-[90%] top-[0] left-[0%] sm:top-[0] sm:left-[-23%] w-screen sm:h-[50vh] dotted-bg z-[-1]"></div>
            <h2 className="text-4xl xs:text-3xl sm:text-5xl  font-bomstad-semibold text-center mb-8">
                How Business Loans Work
            </h2>
            <p className="text-center text-[#000000] font-atkinson mb-8  max-w-xl mx-auto text-lg xs:text-md sm:text-xl leading-[1.1]">
                Getting a business loan is simpler than <br className="block xs:hidden sm:block"/> ever. Here's what the process looks like:
            </p>

            {/* Desktop View */}
            <div className="hidden  md:flex justify-between gap-2 sm:mt-8 ">
                {/* Column 1 */}
                <div className="flex flex-col gap-2 w-1/3">
                    {loanSteps.slice(0, 2).map((step, idx) => (
                        <LoanStepCard key={idx} {...step} />
                    ))}
                </div>

                {/* Column 2 */}
                <div className="flex flex-col gap-2 w-1/3 pt-[100px]">
                    {loanSteps.slice(2, 4).map((step, idx) => (
                        <LoanStepCard key={idx + 2} {...step} />
                    ))}
                </div>

                {/* Column 3 */}
                <div className="flex flex-col gap-2 w-1/3">
                    {loanSteps.slice(4, 6).map((step, idx) => (
                        <LoanStepCard key={idx + 4} {...step} />
                    ))}
                </div>
            </div>


            {/* Mobile View */}
            <div className="grid mt-8 grid-cols-1 gap-6 md:hidden">
                {sortedLoanSteps.map((step, idx) => (
                    <LoanStepCard key={idx} {...step} />
                ))}
            </div>
        </section>
    );
}
